module.exports = __webpack_public_path__ + "img/ic_success_connect.98f20898.svg";